import { EmptyState } from '@scripsteam/scrips-signal-ds';

/**
 * Shared placeholder block for unbuilt tab bodies. Used by the 5 stub
 * tabs while their full content is built in PROD-725..738. The
 * `PersonalDetailsTab` (PROD-725) now ships its real content; the others
 * still consume this.
 *
 * Composes the DS `EmptyState` molecule. It has no slot for a jiraKey
 * badge, so the ticket rides in `title` (`"<jiraKey> — <title>"`) instead
 * of a separate line — folding it in loses no information, it just stops
 * being its own row.
 */

export interface TabPlaceholderProps {
  jiraKey: string;
  title: string;
  subtitle?: string;
}

export function TabPlaceholder({ jiraKey, title, subtitle }: TabPlaceholderProps) {
  return (
    <div className="flex h-full items-center justify-center p-12">
      <EmptyState
        icon="clock"
        title={`${jiraKey} — ${title}`}
        description={subtitle ? `${subtitle} Coming in ${jiraKey}.` : `Coming in ${jiraKey}.`}
      />
    </div>
  );
}
